// import React, { useState, useRef } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { Navigate, useNavigate } from 'react-router-dom';

// import Form from "react-validation/build/form";
// import Input from "react-validation/build/input";
// import CheckButton from "react-validation/build/button";

// import { login } from "../actions/auth";

// const required = (value) => {
//   if (!value) {
//     return (
//       <div className="alert alert-danger" role="alert">
//         This field is required!
//       </div>
//     );
//   }
// };

// const Login = (props) => {
//   let navigate = useNavigate();

//   const form = useRef();
//   const checkBtn = useRef();

//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const [loading, setLoading] = useState(false);

//   const { isLoggedIn } = useSelector(state => state.auth);
//   const { message } = useSelector(state => state.message);

//   const dispatch = useDispatch();

//   const onChangeUsername = (e) => {
//     const username = e.target.value;
//     setUsername(username);
//   };

//   const onChangePassword = (e) => {
//     const password = e.target.value;
//     setPassword(password);
//   };

//   const handleLogin = (e) => {
//     e.preventDefault();

//     setLoading(true);

//     form.current.validateAll();

//     if (checkBtn.current.context._errors.length === 0) {
//       dispatch(login(username, password))
//         .then(() => {
//           navigate("/home");
//           window.location.reload();
//         })
//         .catch(() => {
//           setLoading(false);
//         });
//     } else {
//       setLoading(false);
//     }
//   };

//   if (isLoggedIn) {
//     return <Navigate to="/home" />;
//   }

//   return (
//     <div className="col-md-12">
//       <div className="card card-container">
//         <img src="/img/nomidya.png" alt="Nomidya" style={{}} />

//         {/* <img
//          src="/img/nomidya.png" alt="Nomidya" 
//           alt="profile-img"
//           className="profile-img-card"
//         /> */}

//         <Form onSubmit={handleLogin} ref={form}>
//           <div className="form-group">
//             <label htmlFor="username">Username</label>
//             <Input
//               type="text"
//               className="form-control"
//               name="username"
//               value={username}
//               onChange={onChangeUsername}
//               validations={[required]}
//             />
//           </div>

//           <div className="form-group">
//             <label htmlFor="password">Password</label>
//             <Input
//               type="password"
//               className="form-control"
//               name="password"
//               value={password}
//               onChange={onChangePassword}
//               validations={[required]}
//             />
//           </div>

//           <div className="form-group">
//             <button className="btn btn-primary btn-block" disabled={loading}>
//               {loading && (
//                 <span className="spinner-border spinner-border-sm"></span>
//               )}
//               <span>Login</span>
//             </button>
//           </div>

//           {message && (
//             <div className="form-group">
//               <div className="alert alert-danger" role="alert">
//                 {message}
//               </div>
//             </div>
//           )}
//           <CheckButton style={{ display: "none" }} ref={checkBtn} />
//         </Form>
//       </div>
//     </div>
//   );
// };

// export default Login;
import React, { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";
import { Form, Input, Button, Card, Typography, Spin, Alert } from "antd";
import { UserOutlined, LockOutlined, LoadingOutlined } from "@ant-design/icons";

import { login } from "../actions/auth";

const { Title } = Typography;

const Login = (props) => {
  let navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const { isLoggedIn } = useSelector((state) => state.auth);
  const { message } = useSelector((state) => state.message);

  const dispatch = useDispatch();

  const handleLogin = () => {
    setLoading(true);
    dispatch(login(username, password))
      .then(() => {
        navigate("/home");
        window.location.reload();
      })
      .catch(() => {
        setLoading(false);
      });
  };

  if (isLoggedIn) {
    return <Navigate to="/home" />;
  }

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "linear-gradient(135deg, #74ebd5, #ACB6E5)",
      }}
    >
      <Card
        style={{
          width: 350,
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          borderRadius: 10,
          textAlign: "center",
        }}
      >
        <img
          src="/img/nomidya.png"
          alt="Nomidya"
          style={{ width: 150, marginBottom: 20 }}
        />
        <Title level={3} style={{ color: "#595959" }}>
          Bienvenue sur Nomidya
        </Title>
        <Form
          name="login"
          layout="vertical"
          onFinish={handleLogin}
          style={{ textAlign: "left" }}
        >
          <Form.Item
            name="username"
            rules={[{ required: true, message: "Veuillez entrer votre nom d'utilisateur !" }]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="Nom d'utilisateur"
              size="large"
              onChange={(e) => setUsername(e.target.value)}
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: "Veuillez entrer votre mot de passe !" }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Mot de passe"
              size="large"
              onChange={(e) => setPassword(e.target.value)}
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              block
              size="large"
              loading={loading}
              icon={loading && <LoadingOutlined />}
            >
              Connexion
            </Button>
          </Form.Item>
        </Form>

        {message && (
          <Alert
            message="Erreur"
            description={message}
            type="error"
            showIcon
            style={{ marginTop: 20 }}
          />
        )}
      </Card>
    </div>
  );
};

export default Login;
